<template>
  <div class="fenshu-wapper">
    <p class="language">{{ firstp }}成绩</p>
    <div class="fenshu">
      <div class="ielts">
        <span>IELTS  :</span><el-input
          v-model="input"
          placeholder="总分"/>
        L  :<el-input
          v-model="input"
          placeholder="L"/>
        R  :<el-input
          v-model="input"
          placeholder="R"/>
        W  :<el-input
          v-model="input"
          placeholder="W"/>
        S  :<el-input
          v-model="input"
          placeholder="S"/>
        <el-checkbox v-model="checked">是否UKVI</el-checkbox>
      </div>
      <div class="toefl">
        <span>TOEFL  :</span><el-input
          v-model="input"
          placeholder="总分"/>
        L  :<el-input
          v-model="input"
          placeholder="L"/>
        R  :<el-input
          v-model="input"
          placeholder="R"/>
        W  :<el-input
          v-model="input"
          placeholder="W"/>
        S  :<el-input
          v-model="input"
          placeholder="S"/>
      </div>
    </div>
    <slot
      name="jp"
      v-if="isjpShow"/>
  </div>
</template>
<script>
export default {
  props: {
    isjpShow: {
      type: Boolean,
    },
    firstp: {
      type: String,
    },
  },
  data() {
    return {
      input: '',
      checked: true,
    };
  },
  methods: {
  },
  components: {
  },
};
</script>
